// extracted by mini-css-extract-plugin
export default {"root":"EmptyStateCard-module-root"};